module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "changing-landscapes--cover.311d1b40.jpg";